import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box, Stack } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { Select, KeyboardDatePicker } from '@occc-app/design-system';
import { ScanDataFileStatusType } from '@occc/graphql';

import { PastSubmissionFilterFormValues } from './scan-data-weekly-file.types';

export type PastSubmissionFilterFormProps = {
  onSubmit: FormProps<PastSubmissionFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: PastSubmissionFilterFormValues;
};

const fileStatusSelectOptions: { label: string; value: ScanDataFileStatusType | 'all' }[] = [
  { label: 'All', value: 'all' },
  { label: 'Submitted', value: ScanDataFileStatusType.Submitted },
  { label: 'Partially Submitted', value: ScanDataFileStatusType.PartiallySubmitted },
  { label: 'Not Submitted', value: ScanDataFileStatusType.NotSubmitted },
  { label: 'Submission In Progress', value: ScanDataFileStatusType.SubmissionInProgress },
];

export const PastSubmissionFilterForm = ({
  onSubmit,
  onReset,
  initialValues,
}: PastSubmissionFilterFormProps) => {
  const renderForm: FormRenderProps<PastSubmissionFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<PastSubmissionFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <Stack component='form' px={3} py={3} spacing={3} onSubmit={handleSubmit}>
          <Typography paragraph>Filter Past Submissions</Typography>
          <KeyboardDatePicker label='Submission Date' name='date' maxDate={new Date()} />
          <Select name='status' label='File Status' data={fileStatusSelectOptions} />

          <Box display='flex' justifyContent='flex-end' gap={1}>
            <Button size='large' color='primary' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' size='large' color='primary' variant='contained'>
              Apply
            </Button>
          </Box>
        </Stack>
      );
    },
    [onReset],
  );

  return (
    <Form<PastSubmissionFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
